import { isValidSuiAddress, normalizeSuiAddress } from '@mysten/sui/utils';

export type RecipientKind = 'empty' | 'address' | 'address-prefix' | 'search';

export function getNormalizedSearchLength(raw: string): number {
  return raw.trim().length;
}

export function getNormalizedSuiAddress(raw: string): string | null {
  const value = raw.trim();

  return isValidSuiAddress(value) ? normalizeSuiAddress(value) : null;
}

export function classifyRecipient(raw: string): RecipientKind {
  const value = raw.trim();
  if (!value) return 'empty';
  if (getNormalizedSuiAddress(value)) return 'address';
  if (value.toLowerCase().startsWith('0x')) return 'address-prefix';
  return 'search';
}

export function truncateAddress(address: string, lead = 9, tail = 11): string {
  if (address.length <= lead + tail + 1) return address;
  return `${address.slice(0, lead)}…${address.slice(-tail)}`;
}
